export const DEFAULT_HEARTBEAT_INTERVAL_MS = 15_000;
export const DEFAULT_PEER_TTL_MS = 3 * DEFAULT_HEARTBEAT_INTERVAL_MS;
export const PRESENCE_MESSAGE_MARKER = "__presence";
